import { useEffect } from 'react'
import { enqueueSnackbar } from 'notistack'

export const LEAVE_TEAM_NOTICE_KEY = 'hf-leave-team-notice'

export function storeLeaveTeamNotice(orgName) {
  try {
    sessionStorage.setItem(
      LEAVE_TEAM_NOTICE_KEY,
      JSON.stringify({ orgName: orgName || ''  }),
    )
  } catch {
    // ignore storage failures
  }
}

/** Shows the leave-team destination snackbar after reload. */
export default function LeaveTeamNotice() {
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(LEAVE_TEAM_NOTICE_KEY)
      if (!raw) return
      sessionStorage.removeItem(LEAVE_TEAM_NOTICE_KEY)
      const { orgName } = JSON.parse(raw)
      enqueueSnackbar(
        orgName
          ? `You left the team. You're now in ${orgName}.`
          : 'You left the team.',
        {
          variant: 'success',
          autoHideDuration: 5000,
        },
      )
    } catch {
      // ignore malformed notice payloads
    }
  }, [])

  return null
}
